import React, { useState, useEffect } from 'react';
import { AlertTriangle } from 'lucide-react';
import Card from '../../components/ui/Card';
import Badge from '../../components/ui/Badge';
import Table from '../../components/ui/Table';
import api from '../../services/api';

export default function CriticalExpiry() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    async function load() {
      setLoading(true);
      try {
        const res = await api.get('/v1/osg/critical');
        if (res?.data) setProducts(Array.isArray(res.data) ? res.data : res.data.products || []);
      } catch (e) { console.error(e); }
      finally { setLoading(false); }
    }
    load();
  }, []);

  const columns = [
    { key: 'name', label: 'Товар', render: v => <span style={{ fontWeight: 600 }}>{v}</span> },
    { key: 'barcode', label: 'Штрих-код', render: v => <code style={{ fontSize: 11, color: '#009995', background: '#E6FAFB', padding: '2px 6px', borderRadius: 4 }}>{v || '\u2014'}</code> },
    { key: 'nearest_expiry', label: 'Срок годности', render: v => v ? new Date(v).toLocaleDateString('ru-RU') : '\u2014' },
    { key: 'days_until_expiry', label: 'Осталось', render: v => {
      if (v === undefined || v === null) return '\u2014';
      if (v <= 0) return <Badge variant="error">Просрочен</Badge>;
      if (v <= 3) return <Badge variant="urgent">{v} дн.</Badge>;
      return <Badge variant="warning">{v} дн.</Badge>;
    }},
    { key: 'stock_quantity', label: 'Остаток', render: (v, row) => `${v || 0} ${row.unit || 'шт'}` },
  ];

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <div style={{
          width: 38, height: 38, borderRadius: 10, background: '#FEF2F2',
          display: 'flex', alignItems: 'center', justifyContent: 'center',
        }}>
          <AlertTriangle size={20} color="#EF4444" />
        </div>
        <h1 style={{ fontSize: 24, fontWeight: 800, color: '#0F172A', letterSpacing: '-0.02em' }}>Критические сроки ОСГ</h1>
      </div>
      <Card padding="0">
        {loading ? (
          <div style={{ textAlign: 'center', padding: 48, color: '#94A3B8' }}>
            <div style={{ width: 28, height: 28, borderRadius: '50%', border: '3px solid rgba(0,206,238,0.15)', borderTopColor: '#00CEEE', animation: 'spin 0.8s linear infinite', margin: '0 auto 10px' }} />
            Загрузка...
          </div>
        ) : (
          <Table columns={columns} data={products} emptyText="Нет товаров с критическим сроком" />
        )}
      </Card>
    </div>
  );
}
